const DATE_VALIDATION_ERROR = 'Localization Service: invalid source date value.';

const getTimestampFromDate = (
    date: string | number | Date
): number | undefined => {
    // Handle Date instance
    if (date instanceof Date) {
        return date.getTime();
    }

    // Handle timestamp (in seconds !!)
    if (typeof date === 'number') {
        if (!Number.isFinite(date)) {
            throw new Error(`${DATE_VALIDATION_ERROR} Invalid timestamp: ${date}`);
        }

        return date * 1000;
    }

    // Handle ISO string
    if (typeof date === 'string') {
        if (!date.trim()) {
            throw new Error(`${DATE_VALIDATION_ERROR} Empty string provided.`);
        }

        return (new Date(date)).getTime();
    }

    return undefined;
}

/**
 * Parse a different date sources to normalized Timestamp
 * @param v - Input value (Date, timestamp in seconds, or ISO string)
 * @throws {Error} If the input is invalid or results in an invalid date
 */
const parseDateToTimestamp = (
    v: string | number | Date,
): number => {
    // защита от дурака, в нестрого типизированном коде
    if (!v) {
        throw new Error(`${DATE_VALIDATION_ERROR} Invalid value: ${v}`);
    }

    const time = getTimestampFromDate(v);

    // No condition was triggered
    if (!time) {
        throw new Error(`${DATE_VALIDATION_ERROR} Unsupported value type: ${typeof v}`);
    }

    // Value was parsed but resulted in invalid Date
    if (isNaN(time)) {
        throw new Error(`${DATE_VALIDATION_ERROR} Value: ${v}`);
    }

    return time;
};

export {
    parseDateToTimestamp,
}
